"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _HelpCenterButton = _interopRequireDefault(require("../../../common/components/HelpCenterButton"));

require("../styles/_not-found.scss");

function goHome(a) {
  return function () {
    a.push("/");
  };
}

function NotFound(a) {
  var b = a.history;
  return _react["default"].createElement("div", {
    className: "not-found"
  }, _react["default"].createElement("div", {
    className: "not-found__inner"
  }, _react["default"].createElement(_uiKit.Icon, {
    className: "not-found__icon",
    name: "robot"
  }), _react["default"].createElement("div", {
    className: "not-found__text"
  }, _react["default"].createElement(_uiKit.Text, {
    className: "not-found__header",
    noMargin: "top",
    heading3: !0
  }, "There's nothing here. Are you lost?"), _react["default"].createElement(_uiKit.Text, {
    subtitle: !0,
    noMargin: "bottom"
  }, "This particular page doesn't seem to exist."), _react["default"].createElement(_uiKit.Button, {
    onClick: goHome(b)
  }, "Go Home"))), _react["default"].createElement("div", {
    className: "not-found__assist"
  }, _react["default"].createElement(_uiKit.Text, {
    noMargin: "bottom"
  }, "If you keep running into this problem, try contacting your Account Manager or visit our", _react["default"].createElement("strong", null, _react["default"].createElement(_HelpCenterButton["default"], null)), "for more information.")));
}

var _default = (0, _react.memo)(NotFound);

exports["default"] = _default;